import {
  createResource,
  createSignal,
  createEffect,
  on,
  createReaction,
} from 'https://cdn.jsdelivr.net/npm/solid-js@1.8.22/+esm';
import { createLocalStorage } from 'https://cdn.jsdelivr.net/npm/@solid-primitives/storage@2.0.0/+esm';
import Cookies from 'https://cdn.jsdelivr.net/npm/js-cookie@3.0.5/+esm';

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

window.Shopify.StorefrontCart = (function () {
  const Queries = {
    getCartId(cartId) {
      return {
        query: `
            query getCartId($id: ID!) {
              cart(id: $id) {
                id
              }
            }
          `,
        variables: {
          id: formatId('Cart', cartId),
        },
      };
    },
    createCart(input = {}) {
      return {
        query: `
            mutation createCart($input: CartInput) {
              cartCreate(input:$input) {
                cart {
                  id
                }
              }
            }
          `,
        variables: {
          input,
        },
      };
    },
    getCart(id) {
      return {
        query: `
            query getCart($id: ID!) {
              cart(id: $id) {
                attributes {
                  key
                  value
                }
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
                checkoutUrl
                discountAllocations {
                  discountedAmount {
                    amount
                    currencyCode
                  }
                }
                discountCodes {
                  applicable
                  code
                }
                note
                totalQuantity
                lines(first: 250) {
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                  }
                  nodes {
                    attributes {
                      key
                      value
                    }
                    cost {
                      amountPerQuantity {
                        amount
                        currencyCode
                      }
                      compareAtAmountPerQuantity {
                        amount
                        currencyCode
                      }
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                    }
                    discountAllocations {
                      discountedAmount {
                        amount
                        currencyCode
                      }
                    }
                    id
                    quantity
                    sellingPlanAllocation {
                      sellingPlan {
                        id
                        name
                        priceAdjustments {
                          adjustmentValue
                          orderCount
                        }
                      }
                    }
                    variant: merchandise {
                      ... on ProductVariant {
                        id
                        title
                        product {
                          availableForSale
                          totalInventory
                          title
                          handle
                          onlineStoreUrl
                          options {
                            name
                            values
                          }
                          sellingPlanGroups(first: 1) {
                            nodes {
                              sellingPlans(first: 12) {
                                nodes {
                                  id
                                  name
                                }
                              }
                            }
                          }
                          oosMessage : metafield(namespace: "custom", key: "oos_message") {
                            value
                          }
                        }
                        image {
                          altText
                          height
                          id
                          url
                          width
                        }
                        oosMessage : metafield(namespace: "custom", key: "oos_message") {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
        },
      };
    },
    addToCart(id, lines = []) {
      lines = lines.map((line) => ({
        ...line,
        merchandiseId: formatId('ProductVariant', line.merchandiseId),
        sellingPlanId: line.sellingPlanId ? formatId('SellingPlan', line.sellingPlanId) : undefined,
      }));
      return {
        query: `
            mutation addToCart($id: ID!, $lines: [CartLineInput!]!) {
              cartLinesAdd(cartId: $id, lines: $lines) {
                cart {
                  id
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
          lines,
        },
      };
    },
    removeFromCart(id, lineIds = []) {
      return {
        query: `
            mutation removeFromCart($id: ID!, $lineIds: [ID!]!) {
              cartLinesRemove(cartId: $id, lineIds: $lineIds) {
                cart {
                  id
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
          lineIds: lineIds.map((lineId) => formatId('CartLine', lineId)),
        },
      };
    },
    updateCartNote(id, note = undefined) {
      return {
        query: `
            mutation updateCartNote($id: ID!, $note: String) {
              cartNoteUpdate(cartId: $id, note: $note) {
                cart {
                  id
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
          note,
        },
      };
    },
    updateCartLines(id, lines) {
      return {
        query: `
            mutation updateCartLines($id: ID!, $lines: [CartLineUpdateInput!]!) {
              cartLinesUpdate(cartId: $id, lines: $lines) {
                cart {
                  id
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
          lines: lines.map((line) => ({
            ...line,
            id: formatId('CartLine', line.id),
            sellingPlanId: line.sellingPlanId ? formatId('SellingPlan', line.sellingPlanId) : undefined,
          })),
        },
      };
    },
    updateCartDiscounts(id, cartDiscounts) {
      return {
        query: `
            mutation updateCartDiscounts($id: ID!, $cartDiscounts: [String!]) {
              cartDiscountCodesUpdate(cartId: $id, discountCodes: $cartDiscounts) {
                cart {
                  id
                  discountCodes {
                    code
                    applicable
                  }
                }
                userErrors {
                  field
                  message
                }
              }
            }
          `,
        variables: {
          id: formatId('Cart', id),
          cartDiscounts,
        },
      };
    },
  };
  const [local, setLocal] = createLocalStorage({
    serializer(value, key) {
      return JSON.stringify(value);
    },
    deserializer(value, key) {
      return JSON.parse(value);
    },
  });

  createEffect(
    on(
      () => local.cart_discount_codes,
      (code) => {
        console.log(code, 'THIS IS A TEST');
      }
    )
  );

  const [queue, setQueue] = createSignal([]);

  const client = StorefrontClient({ ...window.Shopify.storefront });

  const [cart, { refetch: refetchCart }] = createResource(async function () {
    let cartId = await initiateCart({
      cartId: Cookies.get('storefront_cart'),
      client,
    });

    cartId = parseId(cartId);

    const res = await client.query(Queries.getCart(cartId));

    return convertCartStructToREST(res?.data?.cart);
  });

  function updateCookies(cartId) {
    cartId = parseId(cartId);
    Cookies.set('storefront_cart', cartId);
    Cookies.set('cart', cartId);
  }

  async function addItems(items) {
    const cartId = Cookies.get('storefront_cart');
    if (!cartId) return track(() => addItems(items));
    return client.query(Queries.addToCart(cartId, items)).then((res) => {
      const data = res?.data?.cartLinesAdd;
      const errors = data?.userErrors;
      updateCookies(data?.cart?.id);
      if (!errors?.length) return res;
      console.error(errors);
      throw new Error('Something went wrong when trying to add items to cart!');
    });
  }

  async function addItem(item) {
    return addItems([item]);
  }

  async function updateNote(note = '') {
    const cartId = Cookies.get('storefront_cart');
    if (!cartId) return track(() => updateNote(note));
    return client.query(Queries.updateCartNote(cartId, note)).then((res) => {
      const data = res?.data?.cartNoteUpdate;
      const errors = data?.userErrors;
      updateCookies(data?.cart?.id);
      if (!errors?.length) return res;
      console.error(errors);
      throw new Error('Something went wrong when trying to update cart note!');
    });
  }

  async function removeItems(ids) {
    const cartId = Cookies.get('storefront_cart');
    if (!cartId) return track(() => removeItems(ids));
    return client.query(Queries.removeFromCart(cartId, ids)).then((res) => {
      const data = res?.data?.cartLinesRemove;
      const errors = data?.userErrors;
      updateCookies(data?.cart?.id);
      if (!errors?.length) return res;
      console.error(errors);
      throw new Error('Something went wrong when removing line items from cart!');
    });
  }

  async function removeItem(id) {
    return removeItems([id]);
  }

  async function updateItems(items) {
    const cartId = Cookies.get('storefront_cart');
    if (!cartId) return track(() => updateItems(items));
    return client.query(Queries.updateCartLines(cartId, items)).then((res) => {
      const data = res?.data?.cartLinesUpdate;
      const errors = data?.userErrors;
      updateCookies(data?.cart?.id);
      if (!errors?.length) return res;
      console.error(errors);
      throw new Error('Something went wrong when updating line items in cart!');
    });
  }

  async function updateItem(item) {
    return updateItems([item]);
  }

  async function updateCartDiscounts(discounts) {
    const cartId = Cookies.get('storefront_cart');
    if (!cartId) return track(() => updateCartDiscounts(discounts));
    return client.query(Queries.updateCartDiscounts(cartId, discounts)).then((res) => {
      const data = res?.data?.cartDiscountCodesUpdate;
      const errors = data?.userErrors;
      updateCookies(data?.cart?.id);
      if (!errors?.length) return res;
      console.error(errors);
      throw new Error('Something went wrong when updating cart discount codes!');
    });
  }

  async function addDiscountCode(discountCode) {
    const codes = [...(local.cart_discount_codes || []), discountCode];
    return updateCartDiscounts(codes).then((res) => {
      const codes = res?.data?.cartDiscountCodesUpdate?.cart?.discountCodes || [];

      const applied = codes.some((code) => code.applicable && code.code === discountCode);

      if (applied) {
        setLocal(
          'cart_discount_codes',
          codes.map((c) => c.code)
        );
      }

      return {
        codes: codes,
        applied,
        discountCode,
        errors: res?.data?.cartDiscountCodesUpdate?.userErrors,
      };
    });
  }

  async function removeDiscountCode(discountCode) {
    const codes = (local.cart_discount_codes || []).filter((code) => code !== discountCode);
    return updateCartDiscounts(codes).then((res) => {
      const codes = res?.data?.cartDiscountCodesUpdate?.cart?.discountCodes || [];

      setLocal(
        'cart_discount_codes',
        codes.map((c) => c.code)
      );

      return {
        codes: codes,
        discountCode,
        errors: res?.data?.cartDiscountCodesUpdate?.userErrors,
      };
    });
  }

  function track(cb) {
    const trackCart = createReaction(cb);
    trackCart(() => cart());
  }

  function createQueueable(cb) {
    function remove() {
      setQueue((q) => {
        return q.slice(1);
      });
    }
    return async function (...args) {
      return new Promise((resolve, reject) => {
        setQueue((q) => {
          function handle() {
            return cb(...args)
              .then((res) => {
                remove();
                return resolve(res);
              })
              .catch((err) => {
                remove();
                return reject(err);
              });
          }
          if (q.length >= 1) {
            q.push(handle);
            return q;
          }
          return [handle];
        });
      });
    };
  }

  createEffect(
    on(queue, (q) => {
      if (!q.length) return refetchCart();
      q[0]();
    })
  );

  function StorefrontClient({ accessToken, shopDomain, apiVersion }) {
    let controller = null;
    const query = async ({ query, variables = {} }) => {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      return fetch(`https://${shopDomain}/api/${apiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
          Accept: 'application/json',
        },
        signal: controller.signal,
        body: JSON.stringify({ query, variables }),
      })
        .then((res) => res.json())
        .then((res) => {
          controller = null;
          return res;
        });
    };

    return {
      query,
    };
  }

  function formatId(type, id) {
    return `gid://shopify/${type}/${id}`;
  }

  function parseId(id) {
    const split = id.split('/');
    return split[split.length - 1];
  }

  function convertObjToKeyValArray(o) {
    return Object.keys(o).map(function (key) {
      return {
        key: key,
        value: o[key],
      };
    });
  }

  function convertCartToInput(cart) {
    const result = {
      note: cart.note || null,
      attributes: convertObjToKeyValArray(cart.attributes || {}),
      lines: (cart.items || []).map(function (line) {
        return {
          attributes: convertObjToKeyValArray(line.properties || []),
          quantity: line.quantity || 1,
          merchandiseId: formatId(`ProductVariant`, line.id),
        };
      }),
    };
    return result;
  }

  async function initiateCart({ client, cartId }) {
    return transferCartToStorefront({ client, cartId }).then(function (id) {
      updateCookies(id);
      return id;
    });
  }

  async function transferCartToStorefront({ client, cartId }) {
    if (!cartId) {
      const res = await client.query(Queries.createCart());
      if (!res?.data?.cartCreate?.cart?.id) throw new Error('Cart creation failed!');
      return res.data.cartCreate.cart.id;
    }

    let res = await client.query(Queries.getCartId(cartId));

    if (res?.data?.cart !== null) return formatId('Cart', cartId);
    const cart = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((cart) => convertCartToInput(cart));

    res = await client.query(Queries.createCart(cart));

    if (!res?.data?.cartCreate?.cart?.id) throw new Error('Cart transfer failed');

    return res.data.cartCreate.cart.id;
  }

  function convertCartStructToREST(cart) {
    const line_item_discount_totals = cart.lines.nodes.reduce(
      (total, line) =>
        total +
        line.discountAllocations.reduce(
          (total, discount) => total + parseFloat(discount.discountedAmount.amount) * 100,
          0
        ),
      0
    );

    const discount_total = cart.discountAllocations.reduce(
      (total, discount) => total + parseFloat(discount.discountedAmount.amount) * 100,
      0
    );

    const subtotal = parseFloat(cart.cost.subtotalAmount.amount) * 100 + line_item_discount_totals;

    return {
      ...cart,
      item_count: cart.totalQuantity,
      items: cart.lines.nodes
        .map((line) => {
          const price = parseFloat(line.cost.amountPerQuantity.amount) * 100;

          const line_price = parseFloat(line.cost.totalAmount.amount) * 100;

          const original_line_price = parseFloat(line.cost.subtotalAmount.amount) * 100;

          const discount_amount = line.discountAllocations.reduce(
            (total, discount) => total + parseFloat(discount.discountedAmount.amount) * 100,
            0
          );

          const sellingPlan = line?.sellingPlanAllocation?.sellingPlan;

          const isDefaultVariant = line.variant.product.options.some(
            (option) => option.name === 'Title' && option.values.includes('Default Title')
          );

          const sellingPlanGroup = line?.variant?.product?.sellingPlanGroups?.nodes[0] || {
            sellingPlans: { nodes: [] },
          };
          const sellingPlans = sellingPlanGroup.sellingPlans.nodes.map((plan) => ({
            id: parseId(plan.id),
            name: plan.name,
          }));

          return {
            metafields: {
              custom: {
                oos_message: line.variant.product.oosMessage?.value,
              },
            },
            available: line.variant.product.availableForSale,
            total_inventory: line.variant.product.totalInventory,
            properties: line.attributes.reduce((props, attr) => {
              props[attr.key] = attr.value;
              return props;
            }, {}),
            price,
            line_price,
            discount_amount,
            original_line_price,
            variant_title: line.variant.title,
            product_title: line.variant.product.title,
            title: isDefaultVariant
              ? line.variant.product.title
              : `${line.variant.product.title} - ${line.variant.title}`,
            image: line.variant.image.url,
            key: parseId(line.id),
            id: parseId(line.variant.id),
            variant_id: parseId(line.variant.id),
            handle: line.variant.product.handle,
            selling_plan: {
              id: sellingPlan?.id ? parseId(sellingPlan.id) : undefined,
              name: sellingPlan?.name ? sellingPlan.name : undefined,
            },
            selling_plans: sellingPlans,
            quantity: line.quantity,
            url: line.variant.product.onlineStoreUrl,
          };
        })
        .reverse(),
      original_total_price: subtotal,
      discounted_subtotal: subtotal - discount_total - line_item_discount_totals,
      discount_total,
      total_price: parseFloat(cart.cost.totalAmount.amount) * 100,
      note: cart.note,
    };
  }

  return {
    addItem: createQueueable(addItem),
    addItems: createQueueable(addItems),
    removeItem: createQueueable(removeItem),
    removeItems: createQueueable(removeItems),
    updateItem: createQueueable(updateItem),
    updateItems: createQueueable(updateItems),
    updateNote: createQueueable(updateNote),
    addDiscountCode: createQueueable(addDiscountCode),
    removeDiscountCode: createQueueable(removeDiscountCode),
    refetchCart,
    cart,
  };
})();
